import React from 'react';

import { Block, Container, Grid } from './styles/index.styled';

const CompanyDetailsCard = ({ industries, locations, products, solutions }) => {
  if (
    industries?.length === 0 &&
    locations?.length === 0 &&
    products?.length === 0 &&
    solutions?.length === 0
  ) {
    return null;
  }

  const details = [
    { title: 'Industries', data: industries },
    { title: 'Products', data: products },
    { title: 'Solutions', data: solutions },
    { title: 'Locations', data: locations },
  ];

  return (
    <Container>
      {details.map(({ data, title }) => (
        <Block>
          <p className="heading">{title}</p>
          <Grid length={data?.length}>
            {data?.map(item => {
              return (
                <p key={item?.id} className="item">
                  {item?.name}
                </p>
              );
            })}
          </Grid>
        </Block>
      ))}
    </Container>
  );
};

export default CompanyDetailsCard;
